import React from 'react';
import { Grid } from '@mui/material';
import facebook from '../../assets/footer-icons/facebook.png';
import twitter from '../../assets/footer-icons/twitter.png';
import linkedin from '../../assets/footer-icons/linkedin.png';
import instagram from '../../assets/footer-icons/instagram.png';
import youtube from '../../assets/footer-icons/youtube.png';
import './footer.scss';
import { Link } from 'react-router-dom';

const Footer = () => {

  const socialLinks = [
    { id: '1', link: '/', icon: facebook },
    { id: '2', link: '/', icon: twitter },
    { id: '3', link: '/', icon: linkedin },
    { id: '4', link: '/', icon: instagram },
    { id: '5', link: '/', icon: youtube },
  ]

  return (
    <div className='footer-wrapper'>
      <div className="footer">
        <Grid container alignItems='center' justifyContent='center'>
          <Grid item lg={4} md={6} xs={12} sx={{ display: 'flex', justifyContent: { md: 'start', xs: 'center' } }}>
            <p className='copy-right'>Copyrights © 2022 All Rights Reserved by
              <span className='buzz'>&nbsp;Buzz<span className='hr'>HR</span></span>
            </p>
          </Grid>
          <Grid item lg={4} md={6} xs={12} sx={{ my: { lg: 0, sm: 1.5, xs: 2.5 }, display: 'flex', justifyContent: { lg: 'center', md: 'end', xs: 'center' } }}>
            <ul className="flex-center-center">
              {socialLinks.map(({ id, link, icon }) => (
                <li className='social-links' key={id}><Link to={link}><img src={icon} alt='social-icon' /></Link></li>
              ))}
            </ul>
          </Grid>
          <Grid item lg={4} md={6} xs={12} sx={{ display: 'flex', justifyContent: { lg: 'end', xs: 'center' } }}>
            <div className='policy text-capitalize d-flex align-center flex-wrap'>
              <span className='text cursor-pointer'>cookies policy</span>
              <span className='seperator'></span>
              <span className='text cursor-pointer'>privacy policy</span>
              <span className='seperator'></span>
              <span className='text cursor-pointer'>terms & conditions</span>
            </div>
          </Grid>
        </Grid>
      </div>
    </div >
  )
}

export default Footer